import jobsRotas from './jobs/JobsRotas'
import ParametrosRotas from './parametros/ParametrosRotas'
import FeriadosRotas from './feriados/FeriadosRotas'
import TiposMovimentosRotas from './tiposMovimentos/TiposMovimentosRotas'

export default {
    path: 'admin',
    name: 'Admin',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    children: [jobsRotas, ParametrosRotas, FeriadosRotas, TiposMovimentosRotas]
}
